"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../styles/theme"));
exports.MarginWrapper = styled_1.default.div `
	margin: 0 ${theme_1.default.layout.spacing.standard};
	@media only screen and (min-width: 768px) {
		margin: 0 ${theme_1.default.layout.spacing.xLarge};
	}
`;
//# sourceMappingURL=MarginWrapper.js.map